export default __webpack_public_path__ + "static/media/academic.47aba20d.svg";